import {
  GetMissingFieldsLevelParameter,
  VerificationLevel,
  VerificationLevels
} from "@wingspanhq/wingspan-api-sdk";

export const selectorIsVerificationStarted = (params: {
  level: GetMissingFieldsLevelParameter;
  verifications?: VerificationLevels;
}): boolean => {
  const key =
    params.level === GetMissingFieldsLevelParameter.BANKING
      ? "banking"
      : params.level === GetMissingFieldsLevelParameter.ENHANCED
        ? "enhanced"
        : "tax";

  const status = params.verifications?.[key];

  return !!status && status !== VerificationLevel.NONE;
};
